import React, { PureComponent } from 'react';

import styles from './styles.less';

interface Props {
	style: React.CSSProperties;
}

export default class Header extends PureComponent<Props> {
	public static defaultProps = {
		style: null,
	};

	public render() {
		const { style } = this.props;

		return (
			<div className={styles.header} style={style}>
				<div className={styles.addOrRemoveCell} />
				<div className={styles.countryCell}>Country</div>
				<div className={styles.brandCell}>Brand name</div>
				<div className={styles.mahCell}>Company</div>
				<div className={styles.dosageCell}>Dosage Form</div>
				<div className={styles.dosageStrengthCell}>Dosage strength</div>
				<div className={styles.packageCell}>Package</div>
				<div className={styles.referencePriceCell}>Price</div>
				<div className={styles.packageForCalculationCell}>Package for calc.</div>
				<div className={styles.packageForCalculationCell}>Dosage strength for calc.</div>
				<div className={styles.comparativePriceCell}>Calc. price</div>
				<div className={styles.selectionCell}>Use for calc.</div>
				<div className={styles.usedForCalculationCell} />
			</div>
		);
	}
}
